
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";
import { socketRequest } from "../../utils/socketRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA, DEV_ADD_roommate } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_isLoading } from "../../reducers/uiReducer";

import { throttle } from 'lodash';

import RoommateList from "./RoommateList";
import PermissionList from "./PermissionList";

const AccessPage: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const roommateAmount = hardmoneyData.roommates.length - 1;

    const keysData = hardmoneyData.propertyUpgrades.find((values, index) => {
        return (values.id == "keys")
    })
    
    if (!keysData) return null;

    const canAddPerson = roommateAmount < keysData.level;

    const [addRoommateSID, setaddRoommateSID] = useState<string>("");

    const handleBlur = () => {
        if (addRoommateSID.trim() !== "") {
            setaddRoommateSID(addRoommateSID); 
        }
    };
    
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
          handleBlur();
          event.currentTarget.blur();
        }
    };
    
    const fetchHouseData = useCallback(
        throttle(async (roomateID: number) => {
            dispatch(SET_isLoading(true));
            try {
                const res: HardMoneyState = await socketRequest("AddRoommate", {
                    houseID: hardmoneyData.houseID,
                    houseOwner: hardmoneyData.houseOwner,
                    playerSID: roomateID,
                }, hardmoneyData);
                if (res) {
                    if (isEnvBrowser()) {
                        //console.log("SET NEW ROOMATE ACCOUNT", res);
                        dispatch(DEV_ADD_roommate(roomateID));
                    } else {
                        dispatch(SET_HOUSEDATA(res));
                    };
                } else {
                    throw new Error("Invalid house data received.");
                }
            } catch (err) {
                console.error("Error purchase house data:", err);
            } finally {
                dispatch(SET_isLoading(false));
            }
        }, 3000),
        [dispatch]
    );

    const handleAddRoommate = (e: React.MouseEvent) => {
        e.preventDefault();

        if (addRoommateSID && addRoommateSID.trim() !== "") {
            console.log(addRoommateSID);
            fetchHouseData(Number(addRoommateSID));
        };
    };

    
    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
               // backgroundColor: "yellow",
                gap: "5vh",
                padding: "3vh 0",
                color: "rgba(255, 255, 255, 0.9)",
            }}
        >
            <div
                style={{
                   // fontWeight: "bold",
                    fontSize: "6vh",
                    width: "100%",
                    //backgroundColor: "orange",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <div
                    style = {{
                        //sbackgroundColor: "red",
                    }}
                >
                    Property Access
                </div>
                <div
                    style = {{
                        //backgroundColor: "red",
                        display: "flex",
                        boxSizing: "border-box",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        gap: "3vh",
                    }}
                >   
                    <div
                        style={{
                            border: "0.2vh solid rgba(90, 90, 90, 0.8)",
                            backgroundColor: "rgba(60, 60, 60, 0.8)",
                            padding: "1vh",
                            fontSize: "1.25vh",
                            fontFamily: 'Noto Sans',
                            fontWeight: "600",
                            borderRadius: "0.75vh",
                            display: "flex",
                            width: "5vw",
                            marginRight: 0,
                        }}
                    >
                        <input
                            type="number"
                            style={{
                                border: "none",
                                background: "transparent",
                                outline: "none",
                                fontSize: "1.5vh",
                                padding: 0,
                                width: "100%",
                                height: "100%",
                                color: "white",
                            }}
                            value={addRoommateSID}
                            onChange={(e) => setaddRoommateSID(e.target.value)}
                            onBlur={handleBlur}
                            onKeyDown={handleKeyDown}
                            placeholder="State ID"
                        />
                    </div>
                    <div
                        onClick={(e) => handleAddRoommate(e)}
                        style={{
                            border: canAddPerson ? `0.2vh solid rgb(${uiData.schemeColor})` : "0.2vh solid rgba(90, 90, 90, 0.8)",
                            backgroundColor: canAddPerson ? `rgba(${uiData.schemeColor}, 0.2)` : "rgba(60, 60, 60, 0.8)",
                            padding: "1vh",
                            fontSize: "1.25vh",
                            fontFamily: 'Noto Sans',
                            fontWeight: "600",
                            borderRadius: "0.75vh",
                            cursor: canAddPerson ? "pointer" : "auto",
                            marginRight: "auto",
                        }}
                    >
                        Add Roommate
                    </div>

                    {roommateAmount}/{keysData.level}
                </div>
            </div>
            
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    //backgroundColor: "gray",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        width: "60%",
                        height: "100%",
                        //background: "yellow",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        //overflow: "auto",
                        flexDirection: "column",
                        gap: "2vh",
                    }}
                >
                    <div
                        style={{
                            fontSize: "3vh",
                           // fontWeight: "bold",
                           fontFamily: 'Oswald',
                           fontWeight: "500",
                        }}
                    >
                        ROOMMATES
                    </div>

                    <RoommateList/>
                </div>
                <div
                    style={{
                        width: "35%",
                        height: "100%",
                        //background: "orange",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        overflow: "hidden",
                        flexDirection: "column",
                        gap: "2vh",
                    }}
                >
                    <div
                        style={{
                            fontSize: "3vh",
                            fontFamily: 'Oswald',
                            fontWeight: "500",
                        }}
                    >
                        PERMISSION LIST
                    </div>
                    {uiData.selectedRoommate > 0 && (
                        <PermissionList/>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AccessPage;
